// ARKA — padrões globais do Chart.js 2 (FONTE CANÔNICA: design/arka/).
// Só tipografia e cinzas neutros: legíveis nos dois temas sem re-render.
// Cores de série: arkaChartTheme(mode), no fim deste arquivo.
import Chart from 'chart.js';
import { arkaColors } from './tokens';

const neutral = '#8A93A3';
const g = Chart.defaults.global;
g.defaultFontFamily = '"Hanken Grotesk", system-ui, sans-serif';
g.defaultFontColor = neutral;
g.defaultFontSize = 12;
if (Chart.defaults.scale && Chart.defaults.scale.gridLines) {
  Chart.defaults.scale.gridLines.color = 'rgba(138, 147, 163, .14)';
  Chart.defaults.scale.gridLines.zeroLineColor = 'rgba(138, 147, 163, .28)';
}
if (g.tooltips) {
  g.tooltips.backgroundColor = '#20252F';
  g.tooltips.titleFontFamily = '"Hanken Grotesk", system-ui, sans-serif';
  g.tooltips.bodyFontFamily = '"JetBrains Mono", ui-monospace, monospace';
  g.tooltips.cornerRadius = 8;
  g.tooltips.xPadding = 10;
  g.tooltips.yPadding = 8;
}

// Cores de série nos tokens (revisão final). Use com o hook useArkaMode() para o
// gráfico acompanhar o tema: série principal = Ember; secundária = neutro.
// O verde/azul antigos (#45e345, #2f6fed) saíram: verde é só status.
const rgba = (hex, a) => {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${a})`;
};
export function arkaChartTheme(mode) {
  const c = arkaColors[mode === 'light' ? 'light' : 'dark'];
  return {
    primary: c.accent,
    primarySoft: rgba(c.accent, mode === 'light' ? 0.12 : 0.16),
    secondary: c.text2,
    secondarySoft: rgba(c.text2, 0.06),
    tick: c.text3,
    grid: rgba(c.text3, 0.16),
    surface: c.surface,
  };
}
